// export const baseUrl = 'http://192.168.2.13:15680'
// export const baseUrl = "https://bgadmin.5uuuu.cn/api"
export const baseUrl = "http://zhanhui.dlzyhy.com/api"